import moment from 'moment-timezone';

const DateFormatted = ({
  date,
  format = 'll',
  timezone,
}: {
  date: moment.MomentInput;
  format?: string;
  timezone?: string;
}) => {
  const instance = timezone ? moment.tz(date, timezone) : moment(date);

  return (
    <span data-toggle="tooltip" title={instance.format('lll')}>
      {instance.format(format)}
    </span>
  );
};

export default DateFormatted;
